<!--  -->
<template>
  <main class="show-container">
    <DisCordBanner />
    <div class="show-container-title">
      {{ $t('lang051') }}
    </div>
    <country-classify
      :currentTabType="currentTabType"
      @on-change="fetchShowList"
    />
    <!-- <div class="section-title-box">
      <h2 class="section-title">{{ $t('lang051') }}</h2>
    </div> -->
    <ul class="show-list">
      <show-room-entrance
        v-for="(room, index) in showList"
        :key="index"
        :room-info="room"
      />
    </ul>
    <div v-show="loading" class="bottom-loading">
      <img :src="require('@assets/img/page-loading.gif')" />
    </div>
  </main>
</template>

<script>
import ShowRoomEntrance from '@components/ShowRoomEntrance';
import CountryClassify from '@components/CountryClassify';
import api from '@services';
import { getCountryCode } from '@assets/js/utils';
import DisCordBanner from '@components/DisCordBanner';

export default {
  scrollToTop: true,
  components: {
    CountryClassify,
    ShowRoomEntrance,
    DisCordBanner
  },
  data() {
    return {
      loading: false,
      currentTabType: 'ALL',
      isLastPage: false,
      showList: [],
      ignoreUids: []
    };
  },
  computed: {},
  async created() {
    if (process.client) {
      this.currentTabType = getCountryCode(this.$i18n.locale);
      const res = await api.getShowbizList({
        tabType: this.currentTabType,
        fetchNum: 50
      });
      const showList = res?.data || [];
      if (showList && showList.length > 0) {
        this.showList = showList;
        const ignoreUids = showList.map((item) => item.owner);
        this.ignoreUids = ignoreUids;
      } else {
        console.log(this.$log);
        this.$log.error('get show list error', {
          msg: JSON.stringify(showList)
        });
      }
    }
  },
  mounted() {
    document.addEventListener('scroll', this.scroll);
    // this.scroll();

    if (window.assetsLoadMonitor) {
      window.assetsLoadMonitor.sendCustomKeyReport({
        type: 'first_screen_time', // 自定义打点类型， type参数不能是page_view_time 和 white_screen_time， 因为会和公共库pv和白屏打点冲突
        extra: {
          // 扩展信息， 业务按需传
          msg: '首屏时间',
          page: 'show/index'
        }
      });
    }
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.scroll);
  },
  methods: {
    fetchShowList(tabType) {
      if (tabType) {
        this.currentTabType = tabType;
        this.showList = [];
        this.ignoreUids = [];
        this.isLastPage = false;
      }
      this.loading = true;
      this.$api
        .getShowbizList({
          tabType: this.currentTabType,
          ignoreUids: this.ignoreUids.join('.'),
          fetchNum: 30
        })
        .then((res) => {
          const data = res?.data || [];
          this.isLastPage = +res.resCode >= 1 || data.length === 0;
          if (data && data.length >= 0) {
            this.showList = this.showList.concat(data);
            const ignoreUids = data.map((item) => item.owner);
            this.ignoreUids = this.ignoreUids.concat(ignoreUids);
          }
          this.loading = false;
          this.scroll();
        });
    },
    scroll() {
      const scrollHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight
      );
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const clientHeight =
        window.innerHeight ||
        Math.min(
          document.documentElement.clientHeight,
          document.body.clientHeight
        );

      if (Math.ceil(clientHeight + scrollTop) >= scrollHeight) {
        const { loading, isLastPage } = this;
        if (!loading && !isLastPage) {
          this.fetchShowList();
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.show-container {
  padding-top: 60px;
  max-width: 1340px;
  margin: 0 auto;

  .show-container-title {
    font-size: 28px;
    font-weight: 600;
    color: #2f3033;
    line-height: 40px;
  }
}

.section-title {
  &::before {
    content: '';
    position: relative;
    top: 3px;
    width: 32px;
    height: 30px;
    float: left;
    background: url(~@assets/img/icon.png) -4px -628px no-repeat;
  }
}

.show-list {
  position: relative;
  overflow: hidden;
  margin-right: -20px; // 与内部的最后一个 margin 对消
}

.bottom-loading {
  margin-top: 20px;
  text-align: center;
}
</style>
